import moment from 'moment';

var RecaptchaUtil = {
    setRecaptchaJs: function () {
        var scriptEl = document.createElement('script');
        scriptEl.src = '//www.google.com/recaptcha/api.js';
        document.head.appendChild(scriptEl);
    },
    checkReCaptcha: function () {
        if (typeof grecaptcha === 'undefined') return;

        const reCaptchaKey = window.grecaptcha.getResponse();
        if (reCaptchaKey.length > 0) return reCaptchaKey;
        return;
    },
};

// -------------------------------------------------------------------------------------------------

var ValidateUtil = {
    errMsg: {
        email: {
            empty: '*You must enter an email.',
            form: '*Please enter a valid email address.',
        },
        pwd: {
            empty: '*Password can’t be blank.',
            length: '*Password must be min 8 characters and Max 20 characters.',
        },
        captcha: {
            empty: '*Please confirm the CAPTCHA.',
        },
        confirmPwd: {
            empty: '*Password confirmation can’t be blank.',
            match: '*Password confirmation doesn’t match password.',
        },
        name: {
            empty: '*Name can’t be blank.',
            length: '*Name must be min 2 characters and Max 15 characters.',
        },
        phoneNo: {
            empty: '*Mobile number can’t be blank.',
            length: '*Mobile number must be min 10 numbers and max 12 numbers.',
        },
        agree: {
            signUpCheck: '*Promo T&C and Data Privacy must be accepted.',
        },
    },
    checkIsEmpty(word) {
        return word == null || word.trim() == '';
    },
    checkIsNotEmpty(word) {
        return word != null && word.trim() != '';
    },
    // 입력을 안해도 되는 데이터에서 사용
    checkIsEmptyChangeSpace(word) {
        if (word == null || word.trim() == '') {
            word = null;
        }
        return word;
    },
    // 입력을 안해도 되는 데이터(날짜)에서 사용
    checkIsEmptyDeleteDate(word) {
        if (word == null || word.trim() == '') {
            word = null;
        }
        return word;
    },
    // 입력을 안해도 되는 데이터(날짜)에서 사용 null 을 반환
    checkIsEmptyChangeNull(word) {
        if (word == null || word.trim() == '') {
            word = null;
        }
        return word;
    },
    checkIsNumber(word) {
        return /^\d+(\.\d+)?$/.test(word);
    },
    checkIsEmail(word) {
        return /.+@.+\..+/.test(word);
    },
    checkPassword(word) {
        // 현재는 자릿수만 체크
        if (word == null) return false;
        return word.length >= 8 && word.length <= 20;
    },
    checkName(word) {
        if (word == null) return false;
        return word.trim().length >= 2 && word.trim().length <= 100;
    },
    checkNameForSMS(word) {
        if (word == null) return false;
        return word.trim().length >= 2 && word.trim().length <= 7;
    },
    checkPhone(word) {
        if (word == null) return false;
        return word.trim().length >= 10 && word.trim().length <= 12;
    },
    checkZipcode(word) {
        if (this.checkIsEmpty(word)) return;
        return word.trim().length <= 7;
    },
    checkTinNumber(tin) {
        if (!tin) return false;
        if (/[^\d]/.test(tin)) return false;

        return tin.trim().length == 12;
    },
    matchPassword(pwd, cPwd) {
        return pwd == cPwd;
    },
    invalidPhoneNumber(input) {
        let phoneNum = input
        if (phoneNum == null) {
            return true;
        }
        
        phoneNum = NumberFormatUtil.convertPhoneGlobalToLocal(phoneNum)
        phoneNum = phoneNum.replace(/\D/g, '');
        
        if (!phoneNum || phoneNum.length != 10) {
            return true;
        }
        return false;
    },
    removeCountryCodePhoneNumber(word) {
        let phoneNum = '';
        if (!word) {
            return null;
        }

        if (word.startsWith('63')) {
            phoneNum = word.substring(2);
        } else {
            phoneNum = word;
        }

        if (phoneNum.length < 7 || phoneNum.length > 20) {
            return null;
        }

        return phoneNum;
    },
    convertPhoneGlobalToLocal(word) {
        // 추후 번호를 다르게 표시해야 할 경우를 대비해서 이 부분에 연관된 페이지를 확인하기 위해 해당 함수 삭제하지 않고 남겨 둠.
        let phoneNum = '';
        if (!word) {
            return null;
        }

        if (word.startsWith('63')) {
            phoneNum = word.substring(2);
        } else {
            phoneNum = word;
        }

        if (phoneNum.length < 7 || phoneNum.length > 20) {
            return null;
        }

        return phoneNum;
    },
    over15Charaters(word) {
        if (!word) return word;

        if (word.length < 16) return word;
        return word.substring(0, 16) + '...';
    },
    over15CharFromFullName(word) {
        if (!word) return word;

        const [first, middle, last] = word.split(' ');
        if (!middle && !last) return ValidateUtil.over15Charaters(first);
        if (!last) return ValidateUtil.over15Charaters([first, middle].join(', '));
        return ValidateUtil.over15Charaters([first, last].join(', '));
    },
    over15CharFromFirstOnly(word) {
        if (!word) return word;
        const [first, middle, last] = word.split(' ');
        return ValidateUtil.over15Charaters(first);
    },
    employeeNameSave(first, middle, last) {
        [first, middle, last] = [first, middle, last].map(this.trimData);

        if (!first || !last) return;
        if (!middle) return [first, last].join(' ');
        return [first, middle, last].join(' ');
    },
    trimData(word) {
        if (!word) return word;
        return word.trim();
    },
    numberWithCommas(number) {
        if(!number) return 0;
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    invalidString(str) {
        return typeof str === 'undefined' || str === null || str === '';
    },
    invalidDecimal(min, max, epsilon, checkValue) {
        let greaterThanMin = checkValue - min > epsilon && Math.abs(checkValue - min) > epsilon;
        let lessThanMax = checkValue - max < epsilon && Math.abs(checkValue - max) > epsilon;
        return !greaterThanMin || !lessThanMax;
    },

    emptyValueToDash(value){
        if(!value) return '-';
        else return value;
    }
};

var AddressUtil = {
    // 만약 수정을 한다면 Employee쪽도 동일한 로직으로 수정 필요함.
    removePlusCode(address) {
        if (!address) return address;

        const value = String(address).trim();
        if (!value) return value;
        
        // Plus Code에서 사용하는 문자: 23456789CFGHJMPQRVWX와 문자+, (ex)GXMX+VQ7
        const result = value
            .replace(/^[23456789CFGHJMPQRVWX]{4,}\+[23456789CFGHJMPQRVWX]{2,}/i, "") // 주소 맨 앞에 포함된 Plus Code를 제거
            .replace(/^[,\s]+|[,\s]+$/g, "") // 문자열 맨 앞 또는 맨 뒤에 남은 콤마/공백을 제거
            .trim();

        return result;
    },
    formatWithoutPlusCode(address) {
        return AddressUtil.removePlusCode(address) || address;
    },
};

// ----------------------------------------------------------------------------------
const DefaultImage = {
    imgUrl: '/images/empty_image_rectangle.png',
    imgUrlForMain: '/images/empty_image_square.png',
    replaceByDefault(e) {
        e.target.src = DefaultImage.imgUrl;
    },
    replaceByDefaultForMain(e) {
        e.target.src = DefaultImage.imgUrlForMain;
    },
};
const CssClassUtil = {
    getProfileBackColor(count) {
        const colorArray = ['bg-orange-400', 'bg-green-400', 'bg-rose-400', 'bg-blue-500', 'bg-purple-400'];
        const number = count % colorArray.length;
        return colorArray[number];
    },
};
// -------------------------------------------------------------------------------------------------

const NumberFormatUtil = {
    fitDecimalFormatWithComma(value, fraction = 2) {
        if (value === null) {
            return '';
        }
        if (Number.isNaN(value)) {
            return String(value);
        }
        let regexp = /\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g;
        let result = Number.parseFloat(value).toFixed(fraction).toString().replace(regexp, ',');
        return result;
    },
    formatLocal(raw) {
        let digits = String(raw ?? '').replace(/\D/g, '');

        if (digits.startsWith('09') || digits.startsWith('08')) {
            digits = digits.slice(1); // "09xxxx..." -> "9xxxx..."
        }

        if (digits.startsWith('9') || digits.startsWith('8')) {
            if (digits.length <= 3) return digits;
            if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
            return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
        }
        return digits; // 그 외는 그대로
    },
    // DB의 63~(국제형 숫자만) -> 화면용 로컬 포맷
    convertPhoneGlobalToLocal(global) {
        const digits =  String(global ?? '').replace(/\D/g, '');

        const local =
            digits.startsWith('63') && digits.length === 12
                ? digits.slice(2) // "63 9xxxxxxxxx" -> "9xxxxxxxxx"
                : digits;

        return this.formatLocal(local);
    }
};

const DateFormatUtil = {
    fitDateFormat(value) {
        if (!value) {
            return;
        }
        return moment(value).format('MM/DD/yyyy');
    },
    monthDayFormat(value) {
        if (!value) {
            return;
        }
        return moment(value).format('MM/DD');
    },
    convertToDateTimeForServerFormat(date) {
        if (!date) {
            return;
        }
        return moment(date).hours(0).minutes(0).seconds(0).format('YYYY-MM-DD HH:mm:ss');
    },
    convertUTCToLocalFormat(utcDateString, formatString) {
        if (!utcDateString || !formatString) {
            console.error("Invalid input: utcDateString or formatString is missing.");
            return null;
        }
        return moment.utc(utcDateString).local().format(formatString);
    },
    // YYMMDDhhmmss --> MM/DD/YYYY(줄바꿈)HH:mm
    fmtGenTimeToMMddyyyyHHmm(genTime) {
        if( !genTime ) return '-';
        
        const yymmddhhmmss = genTime.substr(0, 12);
        return moment(yymmddhhmmss, 'YYMMDDhhmmss').format('MM/DD/YYYY HH:mm').split(' ').join('<br />');
        // 받는 쪽에서 <div v-html="$dateFormatUtil.fmtGenTimeToMMddyyyyHHmm(genTime)"/> 으로 받아야함
    },

    // 2025-03-14T05:23:36Z --> 03/14/2025 13:23  (필리핀 시간으로 표기)
    convertDateTimeToMMddyyyyHHmm(datetime){
        if( !datetime ){
            return "-";
        }
        const date = new Date(datetime);
        const options = { timeZone: "Asia/Manila" };
        const phtDate = new Date(date.toLocaleString("en-PH", options));

        const month = String(phtDate.getMonth() + 1).padStart(2, '0');
        const day = String(phtDate.getDate()).padStart(2, '0');
        const year = phtDate.getFullYear();

        const hours = String(phtDate.getHours()).padStart(2, '0'); // 24시간제
        const minutes = String(phtDate.getMinutes()).padStart(2, '0');

        let newDatetime = `${month}/${day}/${year} ${hours}:${minutes}`.split(' ').join('<br />');
        return newDatetime;
        // 받는 쪽에서 <div v-html="$dateFormatUtil.fmtGenTimeToMMddyyyyHHmm(genTime)"/> 으로 받아야함
    },
    fmtTime_mmddyyyyhhmm(date) {
        if( ! date ) return ''
        // format : date = 2022-09-13T07:04Z
        return moment(date,"YYYY-MM-DDTHH:mm:ssZ").format("MM/DD/YYYY HH:mm");
    },
};

const CommonDataFormatUtil = {
    employmentTypeFormat(type) {
        const employmentTypeMap = {
            FULL_TIME: 'Regular',
            DAILY_WAGE: 'Regular (Daily wage)',
            PROBATION: 'Probationary',
            FIXED_TERM_CONTRACT: 'Contractual',
            PROJECT_BASE: 'Project Base',
            OUTSOURCE: 'Outsourced',
            TEMPORARY: 'Temporary(Casual)',
            HOURLY_WAGE: 'Hourly wage',
            PART_TIME: 'Part-Time',
            CONSULTANT: 'Consultant'
        };
        return employmentTypeMap[type] || '-';
    },
    employmentTypeFormatWithOthers(type) {
        const employmentTypeMap = {
            FULL_TIME: 'Regular',
            DAILY_WAGE: 'Regular (Daily wage)',
            PROBATION: 'Probationary',
            FIXED_TERM_CONTRACT: 'Contractual',
            PROJECT_BASE: 'Project Base',
            OUTSOURCE: 'Outsourced',
            TEMPORARY: 'Temporary(Casual)',
            HOURLY_WAGE: 'Hourly wage',
            PART_TIME: 'Part-Time',
            CONSULTANT: 'Consultant',
            OTHERS: 'Others', /*EmployeementType이 정의되지 않은경우 - FlexBen Only에서 사용됨*/
        };
        return employmentTypeMap[type] || '-';
    },
}

const PasswordPolicyUtil = {
    // 허용되는 특수문자 목록
    ALLOWED_SPECIAL_CHARS: [
        '!', '"', '#', '$', '%', '&', "'", '(', ')',
        '*', '+', ',', '-', '.', '/', ':', ';', '<',
        '=', '>', '?', '@', '[', '\\', ']', '^', '_',
        '`', '{', '|', '}', '~'
    ],

    /**
     * 특수문자 포함 여부 확인
     * @param {string} password
     * @returns {boolean}
     */
    hasAllowedSpecialChar(password) {
        const escaped = this.ALLOWED_SPECIAL_CHARS.map(c => '\\' + c).join('');
        return new RegExp(`[${escaped}]`).test(password);
    },

    /**
     * 대문자 포함 여부 확인
     * @param {string} password
     * @returns {boolean}
     */
    hasUpperCase(password) {
        return /[A-Z]/.test(password);
    },

    /**
     * 소문자 포함 여부 확인
     * @param {string} password
     * @returns {boolean}
     */
    hasLowerCase(password) {
        return /[a-z]/.test(password);
    },

    /**
     * 숫자 포함 여부 확인
     * @param {string} password
     * @returns {boolean}
     */
    hasDigit(password) {
        return /\d/.test(password);
    },

    /**
     * 공백(앞뒤 포함) 여부 확인
     * @param {string} password
     * @returns {boolean}
     */
    hasWhitespace(password) {
        return /\s/.test(password);
    },

    /**
     * 비밀번호 정책에 맞는지 전체 검증
     * @param {string} password
     * @returns {{valid: boolean, message: string}}
     */
    validatePassword(password) {
        if (!password) {
            return { valid: false, message: 'Please provide your login password' };
        }

        const trimmed = password.trim();
        if (trimmed.length !== password.length) {
            return { valid: false, message: 'Password cannot start or end with spaces' };
        }

        if (this.hasWhitespace(password)) {
            return { valid: false, message: 'Password cannot contain spaces' };
        }

        if (password.length < 12 || password.length > 64) {
            return { valid: false, message: 'Password must be 12 to 64 characters long' };
        }

        if (!/^[\x20-\x7E]+$/.test(password)) {
            return {
                valid: false,
                message: `Password must contain only ASCII characters:
                - Uppercase letters: A-Z
                - Lowercase letters: a-z
                - Numbers: 0-9
                - Special characters: ${this.ALLOWED_SPECIAL_CHARS.join(' ')}`
            };
        }

        if (!this.hasUpperCase(password) || !this.hasLowerCase(password) ||
            !this.hasDigit(password) || !this.hasAllowedSpecialChar(password)) {
            return {
                valid: false,
                message:
                    `Password must include 
                    uppercase, lowercase, number, 
                    and at least one of the following special characters:
                    ${this.ALLOWED_SPECIAL_CHARS.join(' ')}`
            };
        }

        return { valid: true, message: 'OK' };
    }
};

const FileValidateUtil = {
    // xlsx 업로드 전용 상수/메시지
    XLSX_EXTENSION: '.xlsx',
    XLS_EXTENSION: '.xls',
    notSupported : 'HR_UTIL_EXCEL_READ_400_FAILED',
    strictOOXML : 'HR_UTIL_EXCEL_OOXML_UNSUPPORTED_400_FAILED',
    empty : 'HR_UTIL_EXCEL_EMPTY_400_FAILED',
    errMsg: {
        xlsxOnly: 'Only .xlsx files are allowed.',
        xls: "This file is saved in an older Excel format (.xls), which isn't supported. Please save as .xlsx and try again.",
        strictXlsx : "This file is saved in Strict Open XML format, which isn't supported. Please re-save as a standard .xlsx file and try again.",
        empty : 'The uploaded Excel file has no data rows. Please fill in the template and try again.'
    },
    isXlsxFile(fileName) {
        if (!fileName) return false;
        return fileName.toLowerCase().endsWith(this.XLSX_EXTENSION);
    },
    isXlsFile(fileName){
        if (!fileName) return false;
        return fileName.toLowerCase().endsWith(this.XLS_EXTENSION);
    },
};

const LeaveUtil = {
    calcLeaveTotal(leavePolicyList, dailyWorkHours = 8) {
        const hoursPerDay = Number(dailyWorkHours) || 8;
        const list = leavePolicyList || [];
        const total = list.reduce(
            (sum, l) => sum + (Number(l.currentDay) || 0) * hoursPerDay + (Number(l.currentHour) || 0),
            0
        );
        return {
            totalDay: Math.floor(total / hoursPerDay),
            totalHour: total % hoursPerDay,
        };
    },
};

export { RecaptchaUtil, ValidateUtil, AddressUtil, DefaultImage, 
    CssClassUtil, NumberFormatUtil, DateFormatUtil, CommonDataFormatUtil, 
    PasswordPolicyUtil, LeaveUtil, FileValidateUtil };
